import { array, bool, func, oneOf, string } from 'prop-types'
import { kuiperClassNames } from '../../utils'
import FileList from '../FileList'
import FileListItem from '../FileListItem'
import { getCheckedStateByChildren } from './utils'

const checkedState = (value, item) => {
  if (value && value.includes(item.id)) {
    return 'all'
  }
  return getCheckedStateByChildren(item, value)
}

const renderItem = (
  value,
  onFileToggle,
  onPathChange,
  currentPath,
  highlightedFileID,
  item
) => {
  if (item.childOptions && item.childOptions.length) {
    const expander = onPathChange.bind(this, [...currentPath, item.id])

    return (
      <FileListItem
        checked={checkedState(value, item)}
        highlighted={item.id === highlightedFileID}
        key={item.id}
        onClick={expander}
        onCheckChange={onFileToggle.bind(null, item)}
        onExpand={expander}
        {...item}
      />
    )
  }

  return (
    <FileListItem
      checked={checkedState(value, item)}
      highlighted={item.id === highlightedFileID}
      key={item.id}
      onClick={onFileToggle.bind(null, item)}
      onCheckChange={onFileToggle.bind(null, item)}
      {...item}
    />
  )
}

const FileBrowserView = ({
  currentPath,
  focused,
  highlightedFileID,
  onBlur,
  onFileToggle,
  onFocus,
  onKeyDown,
  onKeyUp,
  onPathChange,
  theme,
  value,
  ...otherProps
}) => {
  const renderer = renderItem.bind(
    this,
    value,
    onFileToggle,
    onPathChange,
    currentPath,
    highlightedFileID
  )

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={kuiperClassNames('file-browser-view', theme, {
        focused,
        withFileListItems: value.length,
      })}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      tabIndex="-1"
    >
      <FileList
        currentPath={currentPath}
        highlightedFileID={highlightedFileID}
        onFileToggle={onFileToggle}
        onPathChange={onPathChange}
        renderer={renderer}
        {...otherProps}
      />
    </div>
  )
}

FileBrowserView.propTypes = {
  currentPath: array,
  focused: bool,
  highlightedFileID: string,
  onBlur: func,
  onFileToggle: func,
  onFocus: func,
  onKeyDown: func,
  onKeyUp: func,
  onPathChange: func,
  theme: oneOf(['dark', 'light']),
  value: array,
}

export default FileBrowserView
